import ThumbnailCard from "../Cards/ThumbnailCard";
import StatusCard from "../Cards/StatusCard";
import ProductDetailsCard from "../Cards/ProductDetailsCard";
import WeeklySalesCard from "../Cards/WeeklySalesCard";
import ProductTemplateCard from "../Cards/ProductTemplateCard";

const SideComponents = () => {
    return (
        <div className="d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10">
            <ThumbnailCard/>
            <ProductDetailsCard/>
            {/*<StatusCard/>*/}
            {/*<WeeklySalesCard/>*/}
            {/*<ProductTemplateCard/>*/}
        </div>
    )
}
export default SideComponents